export { AmenitiesSpokeContent } from './AmenitiesSpokeContent';
